import { faUser } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useContext } from "react"
import VSpace from "../common/VSpace"
import UsersPageContext from "./UsersPageContext"

const SelectUserView = () => {
  const { isDeletedUser } = useContext(UsersPageContext)

  return <div className="overlay">
    <VSpace size="large">
      <FontAwesomeIcon icon={faUser} size="3x" />
      {!isDeletedUser && <span>SELECT A USER</span>}
      {isDeletedUser && <div>
        <p>DELETED USERS</p>
        <p>(click on any user to restore)</p>
      </div>}
    </VSpace>
  </div>
}

export default SelectUserView